import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b3356a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "right_content" }
const _hoisted_3 = { class: "navbar clearfix" }
const _hoisted_4 = { class: "bread-crumb" }
const _hoisted_5 = { class: "icon_list_right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_7 = { class: "store_info" }
const _hoisted_8 = {
  width: "20",
  height: "16",
  src: "https://image.kilimall.com/kenya/PcImages/static/flags/kenya.gif",
  alt: ""
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kenya", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_13 = { class: "menu_icon_button_div menu_user" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "tags" }

import AppMain from '@/components/AppMain.vue'
import Menu from '@/components/Menu/index.vue'
import screenfullVue from '@/components/screenfull.vue'
import Breadcrumb from '@/components/Breadcrumb/index.vue';
import Navigation from '@/components/Navigation/index.vue';
import KlIcon from '@/components/icon-picker/KLIcon.vue'
import { useRoute,useRouter } from 'vue-router'
import LangSelect from '@/components/lang_select/index.vue'
import { useStore } from "vuex";
import { ref, watch ,computed, nextTick} from 'vue'
import { chat_init_fn } from '@/hooks/index'
import { toHelpCenter } from '@/utils/base';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "905a41be": (_unref(side_wrap_width))
}))

const store = useStore();
  let is_fold: any = ref(true) 
  let side_wrap_width = ref('300px')
  let router = useRouter()
  const route = useRoute()
  let fn_logo_router = ()=>{
      router.push('/home')
  }
  let lang = computed(()=>{
        return store.getters.language
      })
 
  
  const userInfo = ref(localStorage.getItem('UserInfo') ? JSON.parse(localStorage.getItem('UserInfo')) : {})
  const storeInfo = ref(localStorage.getItem('StoreInfo') ? JSON.parse(localStorage.getItem('StoreInfo')) : {})
 
  const ths_select_fn = () => {
    is_fold.value = is_fold.value ? false : true
  }

  const junp_ckip = () => {
    toHelpCenter(storeInfo.value.is_global)
  }
    const viewing = ref(['/KiliMall/afterSale/replacementPlat'])
    const key = () => {
      return route.path
    }  

  watch(() => is_fold.value, (state) => {
    store.dispatch('setLsFold', state) 
    side_wrap_width.value = state ? '300px' : '55px';
  });
  chat_init_fn() // 初始化联系客服

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_webp = _resolveDirective("webp")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout_content", {'scoll_style':viewing.value.includes(key())}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["side_wrap", {'min' : !_unref(is_fold)}])
    }, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(fn_logo_router) && _unref(fn_logo_router)(...args)))
      }, [
        _withDirectives(_createElementVNode("img", {
          src:  _unref(is_fold) ? 'https://image.kilimall.com/seller/seller_center_x3_beta.png' : 'https://image.kilimall.com/seller/seller_logo_m.png'
        }, null, 8, _hoisted_1), [
          [_directive_webp]
        ])
      ]),
      _createVNode(_component_el_scrollbar, {
        ref: (_value, _refs) => {
          _refs['scrollbar'] = _value
        },
        height: "80%",
        always: "",
        onScroll: _ctx.scroll
      }, {
        default: _withCtx(() => [
          _createVNode(Menu, { icon: _unref(is_fold) }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["onScroll"])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "fold_icon menu_icon_button_div",
          onClick: ths_select_fn
        }, [
          _createVNode(KlIcon, {
            icon: _unref(is_fold) ? 'bx-left-indent' : 'bx-right-indent'
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Breadcrumb)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "help-center",
            onClick: junp_ckip
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('home.HelpCenter')) + " ", 1),
            _createVNode(KlIcon, {
              icon: "bxs-help-circle",
              size: "18",
              style: _normalizeStyle({color: 'rgba(0, 0, 0, 0.3)'})
            }, null, 8, ["style"])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
              [_directive_webp]
            ]),
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(storeInfo.value ? storeInfo.value.store_name: ''), 1)
          ]),
          _hoisted_11,
          _createVNode(LangSelect, {
            color: "black",
            class: "set-language"
          }),
          _hoisted_12,
          _createVNode(_component_el_dropdown, { style: {marginLeft:'10px'} }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).dispatch('clearToken')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.logOut')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("img", {
                  src: storeInfo.value ? storeInfo.value.store_image_url :'https://image.kilitest.com/global/images/avatar.png',
                  width: "24",
                  height: "24",
                  alt: ""
                }, null, 8, _hoisted_14), [
                  [_directive_webp]
                ]),
                _createElementVNode("span", null, _toDisplayString(userInfo.value ? userInfo.value.username: ''), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(Navigation)
      ]),
      _createVNode(AppMain)
    ])
  ], 2))
}
}

})